export const getMessageText = (message, userId, showTranslation) => {
	if (message.sender === userId) {
		return (showTranslation && message.translation) || message.original;
	}

	return (!showTranslation && message.translation) || message.original;
};
